export const DEFAULT_LANGUAGE: string = 'fr-FR';
export const DEFAULT_WAKE_WORD: string = 'Bonjour';
